import { render, staticRenderFns } from "./RendererDialog.vue?vue&type=template&id=383d2b19&scoped=true&"
import script from "./RendererDialog.vue?vue&type=script&lang=ts&"
export * from "./RendererDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RendererDialog.vue?vue&type=style&index=0&id=383d2b19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383d2b19",
  null
  
)

export default component.exports